/* LL: reveal once; fail open without IntersectionObserver. */
(() => {
  const root = document.documentElement;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const scan = () => {
    document.querySelectorAll('[data-ll-animate]:not(.is-in)').forEach(el => {
      if (observer) observer.observe(el);
      else el.classList.add('is-in');
    });
  };
  const setup = () => {
    root.classList.remove('ll-js');
    if (observer) observer.disconnect();
    observer = null;
    if (!motion.matches && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    }
    scan();
    root.classList.add('ll-js');
  };
  setup();
  motion.addEventListener('change', setup);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:select', scan);
})();
